import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const PushapiCpcTable = ({ report, onSortChange }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('country')}>Country</th>
                    <th onClick={() => onSortChange('cpc')}>Cpc</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default PushapiCpcTable;


// WEBPACK FOOTER //
// ./src/scenes/PushapiCpc/components/Table/index.js